(function () {
  'use strict';
  function initFaq() {
    var triggers = document.querySelectorAll('[data-faq-trigger]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-faq-item]');
        var answer = item.querySelector('[data-faq-answer]');
        var isOpen = item.hasAttribute('data-open');
        if (isOpen) {
          item.removeAttribute('data-open');
          trigger.setAttribute('aria-expanded', 'false');
          answer.style.maxHeight = '0';
        } else {
          item.setAttribute('data-open', '');
          trigger.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
})();

/* Scroll entrance animations */
(function () {
  'use strict';
  var animEls = document.querySelectorAll(
    '.avora-faq__category, .avora-faq__item, .avora-faq__cta-inner'
  );

  var categories = document.querySelectorAll('.avora-faq__category');
  categories.forEach(function (cat) {
    var items = cat.querySelectorAll('.avora-faq__item');
    items.forEach(function (item, i) {
      item.style.transitionDelay = i * 60 + 'ms';
    });
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  animEls.forEach(function (el) {
    observer.observe(el);
  });
})();
